module.exports = __webpack_public_path__ + "img/about2.b55f5f49.png";